import Repository from "@/repository";

export default {
  state: {
    token: localStorage.getItem("refreshToken") || null,
    isFirstLoading: true,
  },
  actions: {
    async initTokens({ state, commit, dispatch }) {
      if (state.token && state.token !== "undefined") {
        dispatch("refresh");
      } else {
        commit("setIsFirstLoading", false);
      }
    },

    async login({ commit, dispatch }, user) {
      commit("setIsLoader", true);
      const { value, error } = await Repository.AuthActions.login(
        user.username,
        user.password
      );
      if (error) {
        commit("setErrors", error);
        commit("setIsLoader", false);
        return;
      }
      localStorage.setItem("accessToken", value.access);
      localStorage.setItem("refreshToken", value.refresh);
      commit("setToken", value.access);
      dispatch("refreshTokenTimeout");
      commit("setIsLoader", false);
    },

    async refresh({ commit, dispatch }) {
      const refresh = localStorage.getItem("refreshToken");
      const { value, error } = await Repository.AuthActions.refresh(refresh);
      if (error) {
        commit("setErrors", error);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        commit("deleteToken");
        location.reload();
        return;
      }
      commit("setToken", value.access);
      commit("setIsFirstLoading", false);
      localStorage.setItem("accessToken", value.access);
      localStorage.setItem("refreshToken", value.refresh);
      dispatch("refreshTokenTimeout");
    },

    async refreshTokenTimeout({ dispatch }) {
      setTimeout(() => dispatch("refresh"), 10 * 60 * 1000);
    },

    async deleteToken({ commit }) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      commit("deleteToken");
    },
  },
  mutations: {
    setToken(state, value) {
      state.token = value;
      let token = localStorage.getItem("accessToken");
      var base64Url = token.split(".")[1];
      var base64 = decodeURIComponent(
        atob(base64Url)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      state.userId = JSON.parse(base64).user_id
    },
    setIsFirstLoading(state, value) {
      state.isFirstLoading = value;
    },
    deleteToken(state) {
      state.token = null;
    },
  },
};
